import { Box, CheckCheck, EyeIcon, User2, Users, Users2 } from 'lucide-react';
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { NotificationSound } from "../../CommonComponents/CommonNotification";
import { ApiCall, DropDownData, getDateAndTime, handleDateChange, sanitizeInput } from "../../CommonComponents/CustomHooks";
import { CommonApiData, initializeFilterData, virtualPath } from "../../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../../CommonComponents/ExportData";
import { AutoCompleteBoxNew, DateBox, FormButton, InputBox, SelectInputBox } from "../../CommonComponents/InputBox";
import { Table } from "../../CommonComponents/Table";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const LeadEntryReport = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch([])
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [formData, setFormData] = useState({
        dateType: "Lead Date",
        fromDate: getDateAndTime(7).date,
        toDate: getDateAndTime().date,
        leadNo: '',
        prospectName: '',
        contactName: '',
        state: '',
        city: '',
        country: '',
        mobileNo: '',
        category: '',
        group: '',
        item: '',
        status: '',
        leadManager: '',
        company: '',
        leadSource: '',
    });

    const GetStatus = DropDownData('GetLeadStatus')
    const GetCompany = DropDownData('GetCompany')

    const getGroupMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...formData,
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/LeadEntry/LeadEntryReport`, data)
        if (res.Status === 'SUCCESS') {
            setTableData(res);
        } else if (res.Status === 'ERROR') {
            await NotificationSound(res.Status, res.Message, res.Focus, inputrefs);
            setTableData([]);
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.Focus, inputrefs);
        }
    }

    //--handleApproval--//
    const handleApproval = (value) => {
        window.open(`${virtualPath}/LeadEntry/LeadEntryFollowUp?LeadNo=${value}`, "_blank");
    }

    const handleFollowUp = (value) => {
        window.open(`${virtualPath}/LeadEntry/LeadEntryFollowUp?LeadNo=${value}`, "_blank");
    }

    const handleClear = () => {
        setFormData({
            dateType: "Lead Date",
            fromDate: getDateAndTime(7).date,
            toDate: getDateAndTime().date,
            leadNo: '',
            contactName: '',
            state: '',
            city: '',
            country: '',
            mobileNo: '',
            category: '',
            group: '',
            item: '',
            status: '',
            leadManager: '',
            company: '',
            leadSource: '',
        })
        filterData.SearchText = ''
        inputrefs.current['txtDateType'].focus()
        setTableData([])
    }

    const handleChange1 = (event, value) => {
        getGroupMasterData(value);
    };
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleDownloadZip = async (leadNo) => {
        const bodyData = {
            RefId: leadNo,
            CallType: "LeadEntry"
        };
        setIsLoading(true);
        let res = await ApiCall(`/api/Autocomplete/GetDocuments`, bodyData);
        if (res?.status === "SUCCESS") {
            const zip = new JSZip();
            const documentName = res?.documents || res?.data || [];
            if (documentName.length > 0) {
                documentName.forEach((file, index) => {
                    if (file?.base64Document) {
                        zip.file(
                            `${file.fileName || "Document"}_${index}.${file.documentEXT}`,
                            file.base64Document,
                            { base64: true }
                        );
                    }
                });
                const content = await zip.generateAsync({ type: "blob" });
                saveAs(content, `Lead_${leadNo}.zip`);
            }
            else {
                alert("No Documents Found");
            }
        }
        else {
            await NotificationSound(res.status, res.message, res.focus, inputrefs);
        }
        setIsLoading(false);
    };

    const extraPayload = {
        ...filterData,
        ...formData,
        "loginCompanyCode": CommonApiData().companyCode,
    }

    useEffect(() => {
        const companies = GetCompany?.data?.dropDownData;
        if (companies?.length > 0) {
            setFormData(prev => ({
                ...prev,
                company: companies[0]?.valuePart
            }));
        }
    }, [GetCompany?.data])

    useEffect(() => {
        inputrefs.current['txtDateType'].focus()
        document.title = 'Lead Entry Report'
        //getGroupMasterData()
    }, [sortConfig]);

    return (
        <>
            <div className='bg-white rounded-lg shadow-sm p-2'>
                <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                        <Users className="w-6 h-6 text-teal-600" />
                        <h2 className="text-xl font-semibold text-gray-800">Lead Entry Report</h2>
                    </div>
                </div>
                <div className='card-body pb-1'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="row">

                                <SelectInputBox
                                    id="txtDateType"
                                    value={formData.dateType}
                                    label='Date Type'
                                    onChange={(e) => setFormData({ ...formData, dateType: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtFromDate'].focus()
                                        }
                                    }}
                                    divclassname="col-md-3"
                                >
                                    <option value='Lead Date'>Lead Date</option>
                                    <option value='Created Date'>Created Date</option>

                                </SelectInputBox>


                                <DateBox
                                    inputrefs={inputrefs}
                                    label="From Date"
                                    placeholder="DD-MMM-YYYY"
                                    id='txtFromDate'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtToDate'].focus()
                                        };
                                    }}
                                    selected={formData.fromDate === '' ? '' : new Date(formData.fromDate)}
                                    onChange={(e) => handleDateChange(e, setFormData, formData, 'fromDate')}
                                />


                                <DateBox
                                    inputrefs={inputrefs}
                                    label="To Date"
                                    placeholder="DD-MMM-YYYY"
                                    id='txtToDate'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtLeadNo'].focus()
                                        };
                                    }}
                                    selected={formData.toDate === '' ? '' : new Date(formData.toDate)}
                                    onChange={(e) => handleDateChange(e, setFormData, formData, 'toDate')}
                                />

                                <InputBox
                                    label='Lead No'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtProspectName'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    id="txtLeadNo"
                                    placeholder='Enter Lead No'
                                    type="text"
                                    maxLength='30'
                                    value={formData.leadNo}
                                    onChange={(e) => setFormData({ ...formData, leadNo: sanitizeInput(e.target.value) })}
                                />

                                <AutoCompleteBoxNew
                                    id="txtProspectName"
                                    placeholder="Enter Prospect Name"
                                    label='Prospect Name'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtContactName"].focus(); };
                                    }}
                                    autocompleteType='GetProspect'
                                    value={formData.prospectName || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, prospectName: newInputValue })
                                        }
                                    }}
                                />


                                <InputBox
                                    label='Contact Name'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtState'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    id="txtContactName"
                                    placeholder='Enter Contact Name'
                                    type="text"
                                    maxLength='30'
                                    value={formData.contactName}
                                    onChange={(e) => setFormData({ ...formData, contactName: sanitizeInput(e.target.value) })}
                                />

                                <AutoCompleteBoxNew
                                    divclassname='col-md-3'
                                    id="txtState"
                                    placeholder="Enter State"
                                    label='State'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtCity"].focus(); };
                                    }}
                                    autocompleteType='GetState'
                                    value={formData.state || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, state: newInputValue })
                                        }
                                    }}
                                />

                                <AutoCompleteBoxNew
                                    divclassname='col-md-3'
                                    id="txtCity"
                                    placeholder="Enter City"
                                    label='City'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtCountryName"].focus(); };
                                    }}
                                    autocompleteType='GetCity'
                                    value={formData.city || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, city: newInputValue })
                                        }
                                    }}
                                />

                                <AutoCompleteBoxNew
                                    divclassname='col-md-3'
                                    id="txtCountryName"
                                    placeholder="Enter Country"
                                    label='Country'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtMobile"].focus(); };
                                    }}
                                    autocompleteType='GetCountry'
                                    value={formData.country || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, country: newInputValue })
                                        }
                                    }}
                                //maxLength='50'
                                />

                                <InputBox
                                    id="txtMobile"
                                    type="text"
                                    label='Mobile No'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtStatus'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    placeholder='Enter Mobile No'
                                    maxLength='10'
                                    value={formData.mobileNo}
                                    onChange={(e) => setFormData({ ...formData, mobileNo: sanitizeInput(e.target.value) })}

                                />

                                {/*<AutoCompleteBoxNew*/}
                                {/*    divclassname='col-md-3 '*/}
                                {/*    id="txtCategory"*/}
                                {/*    label="Category"*/}
                                {/*    placeholder="Enter Category"*/}
                                {/*    maxLength={15}*/}
                                {/*    inputrefs={inputrefs}*/}
                                {/*    onKeyDown={(e) => {*/}
                                {/*        if (e.key === 'Enter') { inputrefs.current["txtGroup"].focus(); };*/}
                                {/*    }}*/}

                                {/*    autocompleteType='GetCategory'*/}
                                {/*    value={formData.category || ''}*/}
                                {/*    onChange={async (event, newInputValue) => {*/}
                                {/*        newInputValue = newInputValue || ''*/}
                                {/*        if (event.type !== 'keydown') {*/}
                                {/*            setFormData({ ...formData, category: newInputValue })*/}
                                {/*        }*/}
                                {/*    }}*/}
                                {/*/>*/}



                                {/*<AutoCompleteBoxNew*/}
                                {/*    divclassname='col-md-3 '*/}
                                {/*    id="txtGroup"*/}
                                {/*    type="text"*/}
                                {/*    label='Group'*/}
                                {/*    placeholder="Enter Group"*/}
                                {/*    maxLength='50'*/}
                                {/*    inputrefs={inputrefs}*/}
                                {/*    onKeyDown={(e) => {*/}
                                {/*        if (e.key === 'Enter') { inputrefs.current["txtItem"].focus(); };*/}
                                {/*    }}*/}

                                {/*    autocompleteType='GetModelGroupName'*/}
                                {/*    value={formData.group || ''}*/}
                                {/*    onChange={async (event, newInputValue) => {*/}
                                {/*        newInputValue = newInputValue || ''*/}
                                {/*        if (event.type !== 'keydown') {*/}
                                {/*            setFormData({ ...formData, group: newInputValue })*/}
                                {/*        }*/}
                                {/*    }}*/}
                                {/*/>*/}

                                {/*<AutoCompleteBoxNew*/}
                                {/*    divclassname='col-md-3 '*/}
                                {/*    id="txtItem"*/}
                                {/*    type="text"*/}
                                {/*    label='List Item'*/}
                                {/*    placeholder="Enter List Item"*/}
                                {/*    maxLength={15}*/}
                                {/*    inputrefs={inputrefs}*/}
                                {/*    onKeyDown={(e) => {*/}
                                {/*        if (e.key === 'Enter') { inputrefs.current["txtStatus"].focus(); };*/}
                                {/*    }}*/}

                                {/*    autocompleteType='GetModelWiseItem'*/}
                                {/*    value={formData.item || ''}*/}
                                {/*    onChange={async (event, newInputValue) => {*/}
                                {/*        newInputValue = newInputValue || ''*/}
                                {/*        if (event.type !== 'keydown') {*/}
                                {/*            setFormData({ ...formData, item: newInputValue })*/}
                                {/*        }*/}
                                {/*    }}*/}
                                {/*/>*/}

                                <SelectInputBox
                                    id="txtStatus"
                                    value={formData.status}
                                    label='Status'
                                    onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtLeadManager'].focus()
                                        }
                                    }}
                                    divclassname="col-md-3 "
                                >
                                    <option value=''>--Please Select--</option>
                                    {GetStatus?.data?.dropDownData?.map((item, index) =>
                                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                                    )}
                                </SelectInputBox>



                                <AutoCompleteBoxNew
                                    divclassname='col-md-3 '
                                    id="txtLeadManager"
                                    type="text"
                                    label='Lead Manager'
                                    placeholder="Enter Lead Manager"
                                    maxLength={15}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtLeadSource"].focus(); };
                                    }}
                                    autocompleteType='GetLeadManager'
                                    value={formData.leadManager || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, leadManager: newInputValue })
                                        }
                                    }}
                                />

                                {/*<SelectInputBox*/}
                                {/*    id="txtCompany"*/}
                                {/*    value={formData.company}*/}
                                {/*    label='Company'*/}
                                {/*    disabled*/}
                                {/*    onChange={(e) => setFormData({ ...formData, company: e.target.value })}*/}
                                {/*    inputrefs={inputrefs}*/}
                                {/*    onKeyDown={(e) => {*/}
                                {/*        if (e.key === 'Enter') {*/}
                                {/*            inputrefs.current['txtLeadSource'].focus()*/}
                                {/*        }*/}
                                {/*    }}*/}
                                {/*    divclassname="col-md-3 "*/}
                                {/*>*/}
                                {/*    {GetCompany?.data?.dropDownData?.map((item, index) =>*/}
                                {/*        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>*/}
                                {/*    )}*/}

                                {/*</SelectInputBox>*/}

                                <AutoCompleteBoxNew
                                    divclassname='col-md-3 '
                                    id="txtLeadSource"
                                    type="text"
                                    label='Lead Source'
                                    placeholder="Enter Lead Source"
                                    maxLength={15}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtbtnSub"].focus(); };
                                    }}

                                    autocompleteType='GetLeadSourceName'
                                    value={formData.leadSource || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, leadSource: newInputValue })
                                        }
                                    }}
                                />

                            </div>
                        </div>
                    </div>


                </div>
                <div className='card-body'>
                    <FormButton
                        id={'txtbtnSub'}
                        inputrefs={inputrefs}
                        handleSearch={getGroupMasterData}
                        save={false}
                        search={true}
                        handleExport={async () => {
                            await dispatch(setSubLoading(true))
                            handleDownloadExcel(`/api/LeadEntry/LeadEntryReport`, extraPayload, 'Lead Entry Report')
                            await dispatch(setSubLoading(false))
                        }}
                        handleClear={handleClear}
                    />
                </div>
            </div>

            

            {/*<div className="bg-white shadow-lg rounded-xl border border-indigo-100 hover:shadow-xl transition-all duration-300 overflow-hidden p-4 mb-6">
                <div className="flex items-center justify-between mb-2 border-b pb-2">
                    <h3 className="text-base font-bold text-indigo-600">
                        <span className='text-black font-normal'>Lead No:-</span> LE10008
                    </h3>
                    <span className="text-sm">
                        <EyeIcon />
                    </span>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                    <div>
                        <div className="px-3 py-1 font-semibold rounded-lg flex items-center gap-1 bg-red-100 text-red-500 mb-2"><Users2 className='w-4' /> Lead Details</div>
                        <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                Lead Manager:
                            </div>
                            <div className="text-sm font-semibold m-0 text-gray-900">
                                Admin · Admin
                            </div>
                        </div>
                        <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                Lead Source:
                            </div>
                            <div className="text-sm font-semibold m-0 text-gray-900">
                                G
                            </div>
                        </div>
                        <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                Lead Date:
                            </div>
                            <div className="text-sm font-semibold m-0 text-gray-900">
                                11-Dec-2025
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="px-3 py-1 font-semibold rounded-lg flex items-center gap-1 bg-green-100 text-green-500 mb-2"><User2 className='w-4' /> Customer Details</div>
                        <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                CompanyName:
                            </div>
                            <div className="text-sm font-semibold m-0 text-gray-900">
                                CM1001 : P10003
                            </div>
                        </div>
                        <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                ContactName:
                            </div>
                            <div className="text-sm font-semibold m-0 text-gray-900">
                                Shivam Sharma V
                            </div>
                        </div>
                        <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                MobileNo:
                            </div>
                            <div className="text-sm font-semibold m-0 text-gray-900">
                                7894561230
                            </div>
                        </div>
                        <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                EmailID:
                            </div>
                            <div className="text-sm font-semibold m-0 text-gray-900">
                                shivam.sharma@sagarinfotech.in
                            </div>
                        </div>
                        <div className="flex justify-between mt-2">
                            <div className="space-y-1 mb-1 ms-3">
                                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                    City:
                                </div>
                                <div className="text-sm font-semibold m-0 text-gray-900">
                                    DELHI : DELHI
                                </div>
                            </div>
                            <div className="space-y-1 mb-1 ms-3">
                                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                    State:
                                </div>
                                <div className="text-sm font-semibold m-0 text-gray-900">
                                    DELHI : DL
                                </div>
                            </div>
                            <div className="space-y-1 mb-1 ms-3">
                                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                    Country:
                                </div>
                                <div className="text-sm font-semibold m-0 text-gray-900">
                                    India : IN
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="px-3 py-1 font-semibold rounded-lg flex items-center gap-1 bg-orange-100 text-orange-500 mb-2"><Box className='w-4' /> Items Details</div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-1 bg-slate-100 rounded-lg mb-2 p-2">
                            <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                    Item No:
                                </div>
                                <div className="text-sm font-semibold m-0 text-gray-900">
                                    01
                                </div>
                            </div>
                            <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                    Item:
                                </div>
                                <div className="text-sm font-semibold m-0 text-gray-900">
                                    F1 : Hydraulic Oil F
                                </div>
                            </div>
                            <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                    Group:
                                </div>
                                <div className="text-sm font-semibold m-0 text-gray-900">
                                    Oil Filter
                                </div>
                            </div>
                            <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                    Category:
                                </div>
                                <div className="text-sm font-semibold m-0 text-gray-900">
                                    Filters
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-1 bg-slate-100 rounded-lg mb-2 p-2">
                            <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                    Item No:
                                </div>
                                <div className="text-sm font-semibold m-0 text-gray-900">
                                    02
                                </div>
                            </div>
                            <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                    Item:
                                </div>
                                <div className="text-sm font-semibold m-0 text-gray-900">
                                    F1 : Hydraulic Oil F
                                </div>
                            </div>
                            <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                    Group:
                                </div>
                                <div className="text-sm font-semibold m-0 text-gray-900">
                                    Oil Filter
                                </div>
                            </div>
                            <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                    Category:
                                </div>
                                <div className="text-sm font-semibold m-0 text-gray-900">
                                    Filters
                                </div>
                            </div>
                        </div>
                    </div>


                    <div>
                        <div className="px-3 py-1 font-semibold rounded-lg flex items-center gap-1 bg-blue-100 text-blue-500 mb-2"><CheckCheck className='w-4' /> Status</div>
                        <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                FollowUpDate:
                            </div>
                            <div className="text-sm font-semibold m-0 text-gray-900">
                                01-Jan-1900
                            </div>
                        </div>
                        <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                FollowUpRemarks:
                            </div>
                            <div className="text-sm font-semibold m-0 text-gray-900">
                                Test
                            </div>
                        </div>
                        <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                Status:
                            </div>
                            <div className="text-sm font-semibold m-0 text-gray-900">
                                Converted To Order
                            </div>
                        </div>
                        <div className="space-y-1 mb-1 flex items-center gap-2 ms-3">
                            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                FinalStatusRemarks:
                            </div>
                            <div className="text-sm font-semibold m-0 text-gray-900">
                                Test
                            </div>
                        </div>
                    </div>
                </div>
            </div>*/}

            <div className="mt-3">
            <Table className="mt-3"
                loading={isLoading}
                PageName={'LeadEntryReport'}
                handleFilter={() => {
                    getGroupMasterData(1)
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                handleDownloadZip={handleDownloadZip}
                sortConfig={sortConfig}
                Filter={false}
                onlyFilterPage={true}
                handleFollowUp={handleFollowUp}
                handleApproval={handleApproval}
                />
            </div>
        </>
    )
}
export default LeadEntryReport;